import blockLastSendersHelper from './helpers/blockLastSendersHelper';
import showNotificationOnBlockSenders from './helpers/showNotificationOnBlockSenders';
import { tryGetMailboxesFromItemIds } from './helpers/getMailboxes';
import { InstrumentationContext } from 'owa-mail-store';
import { trace } from 'owa-trace';
import { ActionSource } from 'owa-analytics-actions';
import { logUsage } from 'owa-analytics';

/**
 * Block the sender smtp addresses from the given item ids
 * @param itemIdToBlock the item id
 */
export default function blockLastSenderFromReadingPane(
    itemId: string,
    instrumentationContexts: InstrumentationContext[],
    actionSource?: ActionSource
) {
    if (!itemId) {
        trace.error('blockLastSendersFromReadingPane should not be called on invalid items.');
        return;
    }

    logUsage('TnS_BlockSendersFromReadingPane', [actionSource]);

    // De-duped senders
    const mailboxes = tryGetMailboxesFromItemIds([itemId]);
    blockLastSendersHelper(mailboxes, () => {
        showNotificationOnBlockSenders(mailboxes.length);
    });
}
